export default __webpack_public_path__ + "2b4dfe86984686acf14a5327163f93fe.svg";